/*
 * Lazy-loads the full country/currency list into every .CountryList select.
 * The page HTML only contains the popular countries + the current one (SEO: smaller DOM).
 * The full list comes from sections/country-options.liquid via the Section Rendering API.
 * Fires `countries:loaded` on document when done.
 */
(function () {
  var request = null;

  function fetchOptions() {
    if (!request) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      request = fetch(root + '?section_id=country-options')
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          return new DOMParser().parseFromString(html, 'text/html');
        })
        .catch(function (e) {
          request = null; // allow retry
          throw e;
        });
    }
    return request;
  }

  function loadAll() {
    var selects = document.querySelectorAll('.CountryList[data-loaded="false"]');
    if (!selects.length) return Promise.resolve();
    selects.forEach(function (s) { s.dataset.loaded = 'loading'; });

    return fetchOptions().then(function (doc) {
      var options = doc.querySelectorAll('option');
      selects.forEach(function (select) {
        var group = select.querySelector('.country-urls-all') || select;
        var popular = {};
        select.querySelectorAll('.country-urls-popular option').forEach(function (o) { popular[o.value] = true; });
        var current = {};
        group.querySelectorAll('option').forEach(function (o) { current[o.value] = o; });
        var selectedValue = select.value;
        var frag = document.createDocumentFragment();
        options.forEach(function (opt) {
          if (popular[opt.value]) return; // already listed at the top
          if (current[opt.value]) {
            // current country (e.g. Norway): move it into its alphabetical place
            frag.appendChild(current[opt.value]);
            return;
          }
          var clone = opt.cloneNode(true);
          clone.removeAttribute('selected'); // never change the current selection
          frag.appendChild(clone);
        });
        group.appendChild(frag);
        if (selectedValue) select.value = selectedValue;
        select.dataset.loaded = 'true';
      });
      document.dispatchEvent(new CustomEvent('countries:loaded'));
    }).catch(function (e) {
      selects.forEach(function (s) { s.dataset.loaded = 'false'; });
      console.error('Country list failed to load', e);
    });
  }

  window.loadCountryOptions = loadAll;

  function start() {
    if ('requestIdleCallback' in window) requestIdleCallback(loadAll, { timeout: 1500 });
    else setTimeout(loadAll, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Safety net: the (invisible) select sits on top of the button, so listen on both.
  ['pointerdown', 'focusin', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target.closest && e.target.closest('.CountryList, .shipping_location')) loadAll();
    }, { capture: true, passive: true });
  });
})();
